export default __webpack_public_path__ + "static/media/income.a50f434f.svg";